import useProtoMethod from "./useProtoMethod";
import {
  AdminDeactivateIdentityRequest,
  AdminDeactivateIdentityResponse,
  AdminLookupIdentityRequest,
  AdminLookupIdentityResponse,
  AdminListAllAdvisorsRequest,
  AdminListAllAdvisorsResponse,
  ListAdvisorAdministrationRequest,
  ListAdvisorAdministrationResponse,
  ListAdvisorAdministrationMapLocationsRequest,
  ListAdvisorAdministrationMapLocationsResponse,
  CreateAdvisorRequest,
  CreateAdvisorResponse,
  GenerateAdvisorContactsRequest,
  GenerateAdvisorContactsResponse,
  ImpersonationRequest,
  ImpersonationResponse,
  ListAllFamiliesRequest,
  ListAllFamiliesResponse,
  ListFamilyDirectoryMapLocationsRequest,
  ListFamilyDirectoryMapLocationsResponse,
  ListAuditRecordsRequest,
  ListAuditRecordsResponse,
  ListAuditRecordTypesRequest,
  ListAuditRecordTypesResponse,
  UpdateUserRolesRequest,
  UpdateUserRolesResponse,
  GetAllActiveFamilyPlanUtilizationRequest,
  GetAllActiveFamilyPlanUtilizationResponse,
  CreateAdvisorAnnotationResponse,
  CreateAdvisorAnnotationRequest,
  ListAdvisorAnnotationsResponse,
  ListAdvisorAnnotationsRequest,
  UpdateAdvisorAnnotationResponse,
  UpdateAdvisorAnnotationRequest,
  AddRematchAdvisorsRequest,
  AddRematchAdvisorsResponse,
  RemoveAdvisorFromEntityRequest,
  RemoveAdvisorFromEntityResponse,
  ShareRematchOpportunitiesRequest,
  ShareRematchOpportunitiesResponse,
  UpdateRematchSessionRequest,
  UpdateRematchSessionResponse,
  SetRematchScheduledSwitchRequest,
  SetRematchScheduledSwitchResponse,
  ClearRematchScheduledSwitchRequest,
  ClearRematchScheduledSwitchResponse,
  ExportFamilyDataRequest,
  ExportFamilyDataResponse,
  ListAvailableBadgesRequest,
  ListAvailableBadgesResponse,
  GetUserBadgesRequest,
  GetUserBadgesResponse,
  UpdateUserBadgeRequest,
  UpdateUserBadgeResponse,
  ListUsersByBadgeRequest,
  ListUsersByBadgeResponse,
  AdminUpdateFeatureFlagRequest,
  AdminUpdateFeatureFlagResponse,
  AdminUpdateAdvisorServiceRequest,
  AdminUpdateAdvisorServiceResponse,
  GetAccountBotDetailsRequest,
  GetAccountBotDetailsResponse,
  EnsureCoreDocumentsRequest,
  EnsureCoreDocumentsResponse,
  GetAgentThreadInstructionsRequest,
  GetAgentThreadInstructionsResponse,
  AdminCreateAgentCronRequest,
  AdminCreateAgentCronResponse,
  AdminUpdateAgentCronRequest,
  AdminUpdateAgentCronResponse,
  ListDigitalSubscriptionPlaybooksRequest,
  ListDigitalSubscriptionPlaybooksResponse,
  CreateDigitalSubscriptionPlaybookRequest,
  CreateDigitalSubscriptionPlaybookResponse,
  UpdateDigitalSubscriptionPlaybookRequest,
  UpdateDigitalSubscriptionPlaybookResponse,
} from "protogen/admin_service_pb";
import {
  ListRematchSessionsRequest,
  ListRematchSessionsResponse,
} from "protogen/advisors_service_pb";

const useListAllFamilies = () => {
  return useProtoMethod<ListAllFamiliesRequest, ListAllFamiliesResponse>(
    "ListAllFamilies",
    ListAllFamiliesResponse,
  );
};

const useListFamilyDirectoryMapLocations = () => {
  return useProtoMethod<
    ListFamilyDirectoryMapLocationsRequest,
    ListFamilyDirectoryMapLocationsResponse
  >("ListFamilyDirectoryMapLocations", ListFamilyDirectoryMapLocationsResponse);
};

const useListAuditRecords = () => {
  return useProtoMethod<ListAuditRecordsRequest, ListAuditRecordsResponse>(
    "ListAuditRecords",
    ListAuditRecordsResponse,
  );
};

const useListAuditRecordTypes = () => {
  return useProtoMethod<
    ListAuditRecordTypesRequest,
    ListAuditRecordTypesResponse
  >("ListAuditRecordTypes", ListAuditRecordTypesResponse);
};

const useCreateAdvisor = (callback?: (r: CreateAdvisorResponse) => void) => {
  return useProtoMethod<CreateAdvisorRequest, CreateAdvisorResponse>(
    "CreateAdvisor",
    CreateAdvisorResponse,
    { callback },
  );
};

const useUpdateRoles = (callback?: (r: UpdateUserRolesResponse) => void) => {
  return useProtoMethod<UpdateUserRolesRequest, UpdateUserRolesResponse>(
    "UpdateUserRoles",
    UpdateUserRolesResponse,
    { callback },
  );
};

const useAdminListAllAdvisors = (
  callback?: (r: AdminListAllAdvisorsResponse) => void,
) => {
  return useProtoMethod<
    AdminListAllAdvisorsRequest,
    AdminListAllAdvisorsResponse
  >("AdminListAllAdvisors", AdminListAllAdvisorsResponse, { callback });
};

const useListAdvisorAdministration = () => {
  return useProtoMethod<
    ListAdvisorAdministrationRequest,
    ListAdvisorAdministrationResponse
  >("ListAdvisorAdministration", ListAdvisorAdministrationResponse);
};

const useListAdvisorAdministrationMapLocations = () => {
  return useProtoMethod<
    ListAdvisorAdministrationMapLocationsRequest,
    ListAdvisorAdministrationMapLocationsResponse
  >(
    "ListAdvisorAdministrationMapLocations",
    ListAdvisorAdministrationMapLocationsResponse,
  );
};

const useGenerateAdvisorContacts = (
  callback?: (r: GenerateAdvisorContactsResponse) => void,
) => {
  return useProtoMethod<
    GenerateAdvisorContactsRequest,
    GenerateAdvisorContactsResponse
  >("GenerateAdvisorContacts", GenerateAdvisorContactsResponse, { callback });
};

const useImpersonation = (callback?: (r: ImpersonationResponse) => void) => {
  return useProtoMethod<ImpersonationRequest, ImpersonationResponse>(
    "Impersonation",
    ImpersonationResponse,
    { callback },
  );
};

const useAllActiveFamilyPlanUtilization = (
  callback?: (r: GetAllActiveFamilyPlanUtilizationResponse) => void,
) => {
  return useProtoMethod<
    GetAllActiveFamilyPlanUtilizationRequest,
    GetAllActiveFamilyPlanUtilizationResponse
  >(
    "GetAllActiveFamilyPlanUtilization",
    GetAllActiveFamilyPlanUtilizationResponse,
    { callback },
  );
};

const useCreateAdvisorAnnotation = (
  callback?: (r: CreateAdvisorAnnotationResponse) => void,
) => {
  return useProtoMethod<
    CreateAdvisorAnnotationRequest,
    CreateAdvisorAnnotationResponse
  >("CreateAdvisorAnnotation", CreateAdvisorAnnotationResponse, { callback });
};

const useListAdvisorAnnotations = (
  callback?: (r: ListAdvisorAnnotationsResponse) => void,
) => {
  return useProtoMethod<
    ListAdvisorAnnotationsRequest,
    ListAdvisorAnnotationsResponse
  >("ListAdvisorAnnotations", ListAdvisorAnnotationsResponse, { callback });
};

const useUpdateAdvisorAnnotation = (
  callback?: (r: UpdateAdvisorAnnotationResponse) => void,
) => {
  return useProtoMethod<
    UpdateAdvisorAnnotationRequest,
    UpdateAdvisorAnnotationResponse
  >("UpdateAdvisorAnnotation", UpdateAdvisorAnnotationResponse, { callback });
};

const useAddRematchAdvisors = (
  callback?: (r: AddRematchAdvisorsResponse) => void,
) => {
  return useProtoMethod<AddRematchAdvisorsRequest, AddRematchAdvisorsResponse>(
    "AddRematchAdvisors",
    AddRematchAdvisorsResponse,
    { callback },
  );
};

const useRemoveAdvisorFromEntity = (
  callback?: (r: RemoveAdvisorFromEntityResponse) => void,
) => {
  return useProtoMethod<
    RemoveAdvisorFromEntityRequest,
    RemoveAdvisorFromEntityResponse
  >("RemoveAdvisorFromEntity", RemoveAdvisorFromEntityResponse, { callback });
};

const useShareRematchOpportunities = (
  callback?: (r: ShareRematchOpportunitiesResponse) => void,
) => {
  return useProtoMethod<
    ShareRematchOpportunitiesRequest,
    ShareRematchOpportunitiesResponse
  >("ShareRematchOpportunities", ShareRematchOpportunitiesResponse, {
    callback,
  });
};

const useListRematchSessions = (
  callback?: (r: ListRematchSessionsResponse) => void,
) => {
  return useProtoMethod<
    ListRematchSessionsRequest,
    ListRematchSessionsResponse
  >("ListRematchSessions", ListRematchSessionsResponse, { callback });
};

const useUpdateRematchSession = (
  callback?: (r: UpdateRematchSessionResponse) => void,
) => {
  return useProtoMethod<
    UpdateRematchSessionRequest,
    UpdateRematchSessionResponse
  >("UpdateRematchSession", UpdateRematchSessionResponse, { callback });
};

const useSetRematchScheduledSwitch = (
  callback?: (r: SetRematchScheduledSwitchResponse) => void,
) => {
  return useProtoMethod<
    SetRematchScheduledSwitchRequest,
    SetRematchScheduledSwitchResponse
  >("SetRematchScheduledSwitch", SetRematchScheduledSwitchResponse, {
    callback,
  });
};

const useClearRematchScheduledSwitch = (
  callback?: (r: ClearRematchScheduledSwitchResponse) => void,
) => {
  return useProtoMethod<
    ClearRematchScheduledSwitchRequest,
    ClearRematchScheduledSwitchResponse
  >("ClearRematchScheduledSwitch", ClearRematchScheduledSwitchResponse, {
    callback,
  });
};

const useListAvailableBadges = (
  callback?: (r: ListAvailableBadgesResponse) => void,
) => {
  return useProtoMethod<
    ListAvailableBadgesRequest,
    ListAvailableBadgesResponse
  >("ListAvailableBadges", ListAvailableBadgesResponse, { callback });
};

const useGetUserBadges = (callback?: (r: GetUserBadgesResponse) => void) => {
  return useProtoMethod<GetUserBadgesRequest, GetUserBadgesResponse>(
    "GetUserBadges",
    GetUserBadgesResponse,
    { callback },
  );
};

const useUpdateUserBadge = (
  callback?: (r: UpdateUserBadgeResponse) => void,
) => {
  return useProtoMethod<UpdateUserBadgeRequest, UpdateUserBadgeResponse>(
    "UpdateUserBadge",
    UpdateUserBadgeResponse,
    { callback },
  );
};

const useListUsersByBadge = (
  callback?: (r: ListUsersByBadgeResponse) => void,
) => {
  return useProtoMethod<ListUsersByBadgeRequest, ListUsersByBadgeResponse>(
    "ListUsersByBadge",
    ListUsersByBadgeResponse,
    { callback },
  );
};

const useAdminUpdateFeatureFlag = (
  callback?: (r: AdminUpdateFeatureFlagResponse) => void,
) => {
  return useProtoMethod<
    AdminUpdateFeatureFlagRequest,
    AdminUpdateFeatureFlagResponse
  >("AdminUpdateFeatureFlag", AdminUpdateFeatureFlagResponse, { callback });
};

const useAdminUpdateAdvisorService = (
  callback?: (r: AdminUpdateAdvisorServiceResponse) => void,
) => {
  return useProtoMethod<
    AdminUpdateAdvisorServiceRequest,
    AdminUpdateAdvisorServiceResponse
  >("AdminUpdateAdvisorService", AdminUpdateAdvisorServiceResponse, {
    callback,
  });
};

const useGetAccountBotDetails = () => {
  return useProtoMethod<
    GetAccountBotDetailsRequest,
    GetAccountBotDetailsResponse
  >("GetAccountBotDetails", GetAccountBotDetailsResponse);
};

const useEnsureCoreDocuments = () => {
  return useProtoMethod<
    EnsureCoreDocumentsRequest,
    EnsureCoreDocumentsResponse
  >("EnsureCoreDocuments", EnsureCoreDocumentsResponse);
};

const useAdminCreateAgentCron = () => {
  return useProtoMethod<
    AdminCreateAgentCronRequest,
    AdminCreateAgentCronResponse
  >("AdminCreateAgentCron", AdminCreateAgentCronResponse);
};

const useAdminUpdateAgentCron = () => {
  return useProtoMethod<
    AdminUpdateAgentCronRequest,
    AdminUpdateAgentCronResponse
  >("AdminUpdateAgentCron", AdminUpdateAgentCronResponse);
};

const useGetAgentThreadInstructions = () => {
  return useProtoMethod<
    GetAgentThreadInstructionsRequest,
    GetAgentThreadInstructionsResponse
  >("GetAgentThreadInstructions", GetAgentThreadInstructionsResponse);
};

const useListDigitalSubscriptionPlaybooks = () => {
  return useProtoMethod<
    ListDigitalSubscriptionPlaybooksRequest,
    ListDigitalSubscriptionPlaybooksResponse
  >(
    "ListDigitalSubscriptionPlaybooks",
    ListDigitalSubscriptionPlaybooksResponse,
  );
};

const useCreateDigitalSubscriptionPlaybook = () => {
  return useProtoMethod<
    CreateDigitalSubscriptionPlaybookRequest,
    CreateDigitalSubscriptionPlaybookResponse
  >(
    "CreateDigitalSubscriptionPlaybook",
    CreateDigitalSubscriptionPlaybookResponse,
  );
};

const useUpdateDigitalSubscriptionPlaybook = () => {
  return useProtoMethod<
    UpdateDigitalSubscriptionPlaybookRequest,
    UpdateDigitalSubscriptionPlaybookResponse
  >(
    "UpdateDigitalSubscriptionPlaybook",
    UpdateDigitalSubscriptionPlaybookResponse,
  );
};

const useExportFamilyData = (
  callback?: (r: ExportFamilyDataResponse) => void,
) => {
  return useProtoMethod<ExportFamilyDataRequest, ExportFamilyDataResponse>(
    "ExportFamilyData",
    ExportFamilyDataResponse,
    { callback },
  );
};

const useAdminLookupIdentity = (
  callback?: (r: AdminLookupIdentityResponse) => void,
) => {
  return useProtoMethod<
    AdminLookupIdentityRequest,
    AdminLookupIdentityResponse
  >("AdminLookupIdentity", AdminLookupIdentityResponse, { callback });
};

const useAdminDeactivateIdentity = (
  callback?: (r: AdminDeactivateIdentityResponse) => void,
) => {
  return useProtoMethod<
    AdminDeactivateIdentityRequest,
    AdminDeactivateIdentityResponse
  >("AdminDeactivateIdentity", AdminDeactivateIdentityResponse, { callback });
};

export {
  useListAllFamilies,
  useListFamilyDirectoryMapLocations,
  useListAuditRecords,
  useListAuditRecordTypes,
  useAdminListAllAdvisors,
  useListAdvisorAdministration,
  useListAdvisorAdministrationMapLocations,
  useCreateAdvisor,
  useUpdateRoles,
  useGenerateAdvisorContacts,
  useImpersonation,
  useAllActiveFamilyPlanUtilization,
  useCreateAdvisorAnnotation,
  useListAdvisorAnnotations,
  useUpdateAdvisorAnnotation,
  useAddRematchAdvisors,
  useRemoveAdvisorFromEntity,
  useShareRematchOpportunities,
  useListRematchSessions,
  useUpdateRematchSession,
  useSetRematchScheduledSwitch,
  useClearRematchScheduledSwitch,
  useListAvailableBadges,
  useGetUserBadges,
  useUpdateUserBadge,
  useListUsersByBadge,
  useAdminUpdateFeatureFlag,
  useAdminUpdateAdvisorService,
  useGetAccountBotDetails,
  useEnsureCoreDocuments,
  useGetAgentThreadInstructions,
  useAdminCreateAgentCron,
  useAdminUpdateAgentCron,
  useListDigitalSubscriptionPlaybooks,
  useCreateDigitalSubscriptionPlaybook,
  useUpdateDigitalSubscriptionPlaybook,
  useExportFamilyData,
  useAdminLookupIdentity,
  useAdminDeactivateIdentity,
};
